const ENV = (process.env.NODE_ENV || "development") as keyof typeof base_url;

const base_url = {
  development: "http://localhost:3001/api",
  staging: "/api",
  production: "/api",
} as const;

export const API_BASE_URL = base_url[ENV];
